import React from 'react';
import classNames from 'classnames';

import Clickable from '../Clickable';

import ownStyles from './Checkbox.scss';

const Checkbox = ({ value, onChange, text }) => (
  <Clickable
    onClick={() => {
      onChange(!value);
    }}
    className={classNames(
      ownStyles.checkboxIcon,
      value ? 'qm-icon-selection-checkmark' : 'qm-icon-checkbox',
      'flex-row',
    )}
  >
    {!!text && <p className={ownStyles.checkboxText}>{text}</p>}
  </Clickable>
);
export default Checkbox;
